import { render, staticRenderFns } from "./DepositDetails.vue?vue&type=template&id=84023cba&scoped=true"
import script from "./DepositDetails.vue?vue&type=script&lang=js"
export * from "./DepositDetails.vue?vue&type=script&lang=js"
import style0 from "./DepositDetails.vue?vue&type=style&index=0&id=84023cba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84023cba",
  null
  
)

export default component.exports